(function (angular) {
    'use strict';

    angular.module('chat2')
        /**
         *
         */
        .controller('MessageHistoryModalCtrl',
        ["$controller", '$scope', "$uibModalInstance", "teamAvatar",
            function ($controller, $scope, $uibModalInstance, teamAvatar) {

                angular.extend(this, $controller('MessageHistoryCtrl', {
                    $scope: $scope
                }));

                $scope.close = function () {
                    $uibModalInstance.dismiss();
                };
                $scope.teamAvatar = teamAvatar;

            }]);

})(window.angular);
